export default __webpack_public_path__ + "static/media/schweisser.da003b20.jpg";